export enum NotificationType {
  Subscription = 'subscription',
  Follow = 'follow',
  Purchase = 'purchase',
  Like = 'like',
}

export const getNotificationTypes = () => ([{
  label: 'Subscriptions',
  value: NotificationType.Subscription,
}, {
  label: 'Follow',
  value: NotificationType.Follow,
}, {
  label: 'Purchases',
  value: NotificationType.Purchase,
}, {
  label: 'Like',
  value: NotificationType.Like,
}])